import bigCustClueReportNoStrain from './bigCustClueReportNoStrain'
export default bigCustClueReportNoStrain
